import { createStore, applyMiddleware, compose  } from 'redux'
import * as Sentry from "@sentry/react";

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  // Optionally pass options listed below
});

// creates the store
export default (rootReducer, middlewares) => {
  const store = createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), // eslint-disable-line
    compose(applyMiddleware(...middlewares),sentryReduxEnhancer),
  )

  return store
}



// WEBPACK FOOTER //
// ./src/Data/Redux/CreateStore.js